import script from "./Switch.vue?vue&type=script&setup=true&lang=ts"
export * from "./Switch.vue?vue&type=script&setup=true&lang=ts"

import "./Switch.vue?vue&type=style&index=0&id=4b3ddf28&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b3ddf28"]])

export default __exports__